module.exports = __webpack_public_path__ + "img/Playlist_On.710f59cf.svg";